import  { useEffect, useState } from 'react'

import { useParams } from 'react-router-dom'
import { useMutation, useQuery } from 'react-query'
import { toast } from 'react-toastify'

import {  showArticles, updateArticles } from '../../../../MyApi/sb/articles'

import PageHeader from '../../../../Components/UI/PageHeader'
import EditArticles from '../../../../Components/sb/articles/articlesUpdate/AddCompanies'
import LoadingSpinner from '../../../../Components/UI/spinner'



const ArticlesUpdate = () => {
const [name ,setName]= useState("")
const [description ,setDescription] = useState("")
const [core_category_id, setCategoryId]=useState("")
const [image ,setImage] = useState("")
const [active,setActive] =useState(1)
const {id} =useParams()
const lang = localStorage.getItem("i18nextLng")
const [selectedlangCode ,setSelectedLangCode] =useState(lang)
const {data , isLoading}= useQuery(["showArticles",id ,selectedlangCode], ()=>showArticles(id ,selectedlangCode))
const articles = data?.data || {}
 const mutation = useMutation("postArticles" , (postData)=>updateArticles(postData ,id) ,{
    onSuccess:(data)=>{
        toast.success(`${data.message}`)

    },
    onError :(error)=>{
        toast.error(`${error.response.data.message}`)
    }
 })
 useEffect(()=>{
  setName(articles.name)
  setDescription(articles.description)
  setActive(articles.active)
  setCategoryId(articles.core_category_id)
  setImage(articles.image)
 },[data])

 const handlePostRequest =()=>{
  const formData =new FormData()
  formData.append("name" ,name)
  formData.append("description" ,description)
  formData.append("active" ,active)
  formData.append("core_category_id" ,core_category_id)
  formData.append("image"  , image)
  formData.append("lang_code" ,selectedlangCode)
  mutation.mutate(formData)
 }
 const isDisabled= ()=>{
    return false
 }
 const onSelectChange =(e)=>{
  setSelectedLangCode(e.target.value)
 }
 if(isLoading){
  return <LoadingSpinner/>
 }
  return (   

    <div>
        <PageHeader title="Edit Article" showSelect isLoading={mutation.isLoading} onSelectChange={onSelectChange} showBack={true} saveButton={true} isdisbled={isDisabled} handlePostRequest={handlePostRequest} />
        <EditArticles setImage={setImage} image={image} categoryId={core_category_id}  setCategoryId={setCategoryId} setActive={setActive} active={active} setName={setName} name={name} description={description} setDescription={setDescription}/>
    </div>
  )
}

export default ArticlesUpdate